export default "__VITE_ASSET__rtdnAmgdxocHXpi7Oi$iSg__"